
    window.lhnJsSdkInit = function () {
        lhnJsSdk.setup = {
            application_id: "396ec94a-9a4a-4787-1e13-432021490f39",
            application_secret: "fgyxk8hpkds35gtfh89dgistzgthb0/vw4tkpqepgqjkzd83o3"
        };
        lhnJsSdk.controls = [{
            type: "hoc",
            id: "152a9961-34ba-4c3a-82a3-a20939ce5d1b"
        }];

        lhnJsSdk.dictionary = { agentConnecting: "Connected to CHFA" }
    };

    (function (d, s) {
        var newjs, lhnjs = d.getElementsByTagName(s)[0];
        newjs = d.createElement(s);
        newjs.src = "https://developer.livehelpnow.net/js/sdk/lhn-jssdk-current.min.js";
        lhnjs.parentNode.insertBefore(newjs, lhnjs);
    }(document, "script"));
